/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const TuneHorizontal: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="tune-horizontal" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M510 736.6666666666667H396.6666666666667V906.6666666666669H170V1020H396.6666666666667V1190H510V736.6666666666667zM1190 906.6666666666669H623.3333333333333V1020H1190V906.6666666666669zM1190 340H963.3333333333331V170H850V623.3333333333334H963.3333333333331V453.3333333333334H1190V340zM736.6666666666666 340H170V453.3333333333334H736.6666666666666V340z" : "M408 589.3333333333333H317.3333333333334V725.3333333333333H136V816H317.3333333333334V952H408V589.3333333333333zM952 725.3333333333333H498.6666666666667V816H952V725.3333333333333zM952 272H770.6666666666667V136H680V498.6666666666666H770.6666666666667V362.6666666666667H952V272zM589.3333333333334 272H136V362.6666666666667H589.3333333333334V272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
TuneHorizontal.displayName = `Blueprint5.Icon.TuneHorizontal`;
export default TuneHorizontal;
